<template>
		<el-drawer
			:visible.sync="visibleShow"
			:show-close="true"
      size="1000px"
			id="monitorPlanDrawerDrawer"
    >
		<div slot="title" >
			<el-row type="flex" align="middle">
				<el-col :span="16">
					<div style="font-size: 20px;font-weight: bold">{{ selectPlan.planname }}</div>
					<div>通知人: {{ selectPlan.noticeusername }}</div>
				</el-col>
				<el-col :span="8">
					<span>监控类型: {{ selectPlan.plantype === '0' ? '标价' : '到手价' }}</span>
					<el-button class="g-margin-left" size="small" type="plain" @click="download">下载数据</el-button>
				</el-col>
			</el-row>
		</div>
		<div class="content" v-loading="loading2"
		element-loading-text="拼命加载中"
		element-loading-spinner="el-icon-loading">
			<el-table
				class="g-margin-top"
				:data="monitorPlanDetail">
				<el-table-column
					label="序号"
					type="index"
					width="50">
				</el-table-column>
				<el-table-column
					label="监控时间"
					width="220">
					<template slot-scope="scope">
						<span>{{ scope.row.monitor_time|fullTime }}</span>
					</template>
				</el-table-column>
				<el-table-column
					label="产品型号"
					width="80">
					<template  slot-scope="scope">
						<el-popover
							placement="bottom"
							width="200"
							trigger="hover">
							<div>
								<span v-for="(item, i) in scope.row.productidlist" :key="i" class="g-block">
									{{ item.product }}
								</span>

							</div>
							<span slot="reference">{{ scope.row.productidlist.length }}个</span>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column
					label="监控总链接">
					<template slot-scope="scope">
						<span>{{ scope.row.count }}条</span>
					</template>
				</el-table-column>
				<el-table-column
					label="违规链接">
					<template slot-scope="scope">
						<span>{{ scope.row.islowpricecount }}条</span>
					</template>
				</el-table-column>
				<el-table-column
					width="180"
					label="操作">
					<template slot-scope="scope">
						<div class="g-inline-block" style="color: #108cee;cursor: pointer;" @click="onCheckDetail(scope.row)">
							详细数据
						</div>
					</template>
				</el-table-column>
			</el-table>
			<div v-if="moreShow" class="btnMore">
				<el-button size="small" @click="more()" v-loading="loading">加载更多</el-button>
			</div>
			<!-- <Pagination
        v-if="totalPage > 0"
        class="pagination"
        :total="totalPage"
        v-model="pagination"
        @onChange='load'
      /> -->

		</div>
		</el-drawer>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import Pagination from 'components/pagination/pagination'
export default {
	name: 'monitorPlanDrawer',

	components:{
		Pagination
	},

	watch: {
		visibleShow(val) {
			if(val) {
				this.initSelectPlan();
				this.load();
			}
		}
	},

	props: {
		modalInfo: {
			type: Object,
			default:()=>{}
		}
	},
	data () {
		return {
			loading:true,
			loading2:true,
			moreShow:true,
			visibleShow:false,
			selectPlan: {},
			totalPage: 0,
			monitorPlanDetail: [],
			pagination: {
        size: 10,
        current: 1
      },
		}
	},
	methods: {
		more() {
			this.pagination.size = this.pagination.size + 10
			this.load()
		},
		initSelectPlan() {
			this.selectPlan = this.monitorPlanList.find(item => {
				return item.id == this.modalInfo.id
			});
			this.selectPlan.noticeusername = this.selectPlan.noticeusername ? this.selectPlan.noticeusername.replace(',', '、') : '';
		},
		download() {
			let url = `hcm/hcmNewMonitorProduct/downloadDetailCountById?id=${this.modalInfo.id}`
      window.open(url)
		},
		...mapActions([
			'reqMonitorPlanDetail'
    ]),
		load() {
			this.loading = true
			let params = {
				pageNo: this.pagination.current,
				pageSize: this.pagination.size,
				id: this.modalInfo.id
			}
			this.reqMonitorPlanDetail(params).then(res => {
				this.loading = false
				this.loading2 = false
				let arr = []
				this.monitorPlanDetail = res.content
				// this.totalPage = res.totalElements;
				if (this.monitorPlanDetail.length < this.pagination.size) {
					this.moreShow = false
				} else {
					this.moreShow = true
				}
			});
		},
		onCheckDetail(row){
			let monitortime = this.$options.filters.fullTime(row.monitor_time);
			let routeData = this.$router.resolve({
					path:'/monitorPlanDeal',
					query:{
						id:this.modalInfo.id,
						monitortime:monitortime
					}
			})
			window.open(routeData.href, '_blank');
		}
	},

	computed: {
		...mapState({
			// monitorPlanDetail: state => state.monitorPlan.monitorPlanDetail,
			monitorPlanList: state => state.monitorPlan.monitorPlanList
		}),
	},
}
</script>

<style lang='scss'>
@import "style/activityDeclaration.scss";
#monitorPlanDrawerDrawer {
	.el-drawer {
		.btnMore{
		  text-align: center;
		  margin-top: 20px;
		}
		.el-drawer__header{
			margin: 0;
			padding: 10px 15px!important;
		}
		.el-drawer__body{
			padding: 10px!important;
	    height: auto;
	    overflow: auto;
		}
		.el-icon-close{
			display: block!important;
	    position: absolute;
	    top: 10px;
	    right: 20px;
		}
	}
}
</style>
